import { Avatar, Chip, Skeleton } from '@mui/material'
import { useSelector } from '../../redux/hooks/useSelector'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import { TransparentIconButton } from '../common/TransparentIconButton'
import { EditRounded } from '@mui/icons-material'
import { newThemeObject } from '../../newTheme'
import { tokens } from '../../styles/tokens'
import { useDispatch } from 'react-redux'
import { openDialog } from '../../redux/actions/dialogActions'
import { CLIENT_INFORMATION_DIALOG_ID } from '../../constants/dialogConstants'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { isDistributorUser } from '../../utils/distributor'

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    backgroundColor: tokens.color.white,
    boxShadow: tokens.shadow.sm,
    padding: theme.spacing(2.5),
    borderRadius: newThemeObject.roundness.basic,
    height: '85px',
  },
  avatar: {
    height: '2rem',
    width: '2rem',
  },
  title: {
    fontSize: '1rem',
    fontWeight: tokens.font.weight.semibold,
    letterSpacing: '-0.01em',
    color: tokens.color.neutral[900],
  },
  subtitle: {
    fontSize: '0.75rem',
    color: tokens.color.neutral[500],
  },
  text: {
    margin: 0,
  },
}))

const ClientCard = () => {
  const classes = useStyles()
  const client = useSelector(state => state.clients.client)
  const user = useSelector(state => state.auth.user)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { clientId } = useParams<{ clientId: string }>()

  let symbols
  let name = ''
  if ( client.company ) {
    name = client.companyName
  } else {
    if (!!client.firstName) {
      name += client.firstName
    }
    if (!!client.surname) {
      if (name.length > 0) name += ' ' + client.surname
      else name += client.surname
    }
  }
  if (!!client.firstName) {
    symbols = client?.firstName.charAt(0).toUpperCase() + client?.surname.charAt(0).toUpperCase()
  }

  return (
    <span>
      {clientId === client.clientId.toString() && (
        <div className={classes.wrapper}>
          <Avatar className={classes.avatar}>{symbols}</Avatar>
          <span>
            <p className={classNames(classes.text, classes.title)}>{name}</p>
            <p className={classNames(classes.text, classes.subtitle)}>{client.personalNumber}</p>
          </span>
          {client.incomplete && (
            <Chip size="small" color="warning" variant="outlined" label={t('CLIENT_INCOMPLETE')} />
          )}
          { !isDistributorUser(user) &&
          <TransparentIconButton
            onClick={() => {
              dispatch(
                openDialog(CLIENT_INFORMATION_DIALOG_ID, {
                  dialogTitle: t('CLIENT_EDIT'),
                  client,
                  type: 'edit',
                })
              )
            }}
            icon={<EditRounded />}
          />
          }
        </div>
      )}
      {clientId !== client.clientId.toString() && (
        <div className={classes.wrapper}>
          <Skeleton variant="circular" width={32} height={32} />
          <span>
            <Skeleton variant="text" width={120} height={22} />
            <Skeleton variant="text" width={80} height={17} />
          </span>
          { !isDistributorUser(user) &&
          <TransparentIconButton
            disabled={true}
            onClick={() => {
              dispatch(
                openDialog(CLIENT_INFORMATION_DIALOG_ID, {
                  dialogTitle: t('CLIENT_EDIT'),
                  client,
                  type: 'edit',
                })
              )
            }}
            icon={<EditRounded />}
          />
          }
        </div>
      )}
    </span>
  )
}

export default ClientCard
